import { PasswordUpdateForm } from 'components/templates';
import { usePasswordUpdateForm } from 'hooks/usePasswordUpdateForm/usePasswordUpdateForm';

export const ParentPasswordUpdatePage = () => {
    const {
        form,
        formInitialData,
        updatePasswordError,
        isUpdatePasswordLoading,
        onUpdatePasswordFinish,
    } = usePasswordUpdateForm();

    return (
        <PasswordUpdateForm
            form={form}
            initialValues={formInitialData}
            isLoading={isUpdatePasswordLoading}
            error={updatePasswordError}
            onFinish={onUpdatePasswordFinish}
        />
    );
};
